import {Popup} from "./Popup";

window.addEventListener('DOMContentLoaded', () => {
    const popups = document.querySelectorAll('.popup-wrapper');
    popups.forEach((popupWrapper) => {
        new Popup(popupWrapper);
    });
});